import { Field } from "redux-form";

import {
  Button,
  Popover,
  Stack,
  Typography,
} from "@braintrust/braintrust-ui-components";
import { SettingsRoundedIcon } from "@braintrust/braintrust-ui-components/Icons";
import { VisibilitySettingsSelectField } from "@js/apps/jobs/apps/create-job/fields/visibility-setting-field";

export const VisibilitySettingsPopover = () => {
  return (
    <Popover
      anchor={
        <Button
          variant="white-violet"
          shape="squared"
          startIcon={<SettingsRoundedIcon />}
        >
          Visibility
        </Button>
      }
    >
      <Stack sx={{ gap: 1, p: 3 }}>
        <Typography component="p">Post visibility</Typography>
        <Field name="is_private" component={VisibilitySettingsSelectField} />
      </Stack>
    </Popover>
  );
};
